{
  "setting_toggle_row": {
    "staff_only_help": "Please <contact>contact support</contact> to have this setting updated"
  },
  "setting_action_row": {
    "edit": "Edit"
  },
  "plan_upgrade_prompt": {
    "available_on_pro": "Available on Pro and Enterprise (and as an addon)",
    "available_on_growth": "Available on Growth, Pro, and Enterprise",
    "change_plan": "Change plan"
  }
}
